<script setup lang="ts"></script>

<template>
  <div class="min-h-screen bg-gray-50 font-lato text-gray-900">
    <slot />
  </div>
</template>
